import { Link, useLocation } from "react-router-dom";
import "./BreadCrumb.css";

const formatLabel = (str) => {
  if (!str) return "";
  return str
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const BreadCrumb = () => {
  const location = useLocation();
  const path = location.pathname;
  const items = path.slice(1).split("/").filter(Boolean);

  const pathArr = [{ label: "Dashboard", path: "/" }];

  if (items.length > 0 && items[0] !== "") {
    let stringPath = "";
    items.forEach((item, index, array) => {
      if (item === "dashboard" && index === 0) return;
      if (!isNaN(item)) return;

      if (!isNaN(array[index + 1])) {
        stringPath += "/" + item + "/" + array[index + 1];
        if (item === "edit") {
          pathArr.push({ label: "Edit", path: stringPath });
        } else {
          const refLabel = array[index - 1] || item;
          pathArr.push({ label: `${formatLabel(refLabel)} #${array[index + 1]}`, path: stringPath });
        }
      } else {
        stringPath += "/" + item;
        pathArr.push({ label: formatLabel(item), path: stringPath });
      }
    });
  }

  return (
    <nav aria-label="Breadcrumb" className="breadcrumb-bar">
      {pathArr.map((obj, i) => {
        const isLast = i === pathArr.length - 1;

        return (
          <span key={i} className="bc-item">
            {i > 0 && <span className="bc-separator">/</span>}
            {isLast ? (
              <span className="bc-current">{obj.label}</span>
            ) : (
              <Link to={obj.path} className="bc-link">{obj.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default BreadCrumb;